import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';
import { UtilityService } from '../../../core/services/utility.service';

@Component({
  selector: 'tt-stock-batch-corr-qty',
  templateUrl: './stock-batch-corr-qty.component.html',
  styleUrls: ['./stock-batch-corr-qty.component.css']
})
export class StockBatchCorrQtyComponent implements OnInit {
    stockBatchKeyno;

    public edit?: Edit;

    public selectListStockCorrectionCodes: StockCorrectionCodeItem[] = [];

    public saving = false;

    constructor(private stateService: StateService, private utility: UtilityService, private modal: ModalService, private datatask: DataTaskService) {
        this.stockBatchKeyno = this.stateService.getStateParams()['stockbatch_keyno'];
    }

    private async loadEdit() {
        if (!!this.stockBatchKeyno) {
            this.edit = (await this.datatask.Post(2480, { stockbatch_keyno: this.stockBatchKeyno }))[0];
        }
    }

    private async loadStockCorrectionCodes() {
        this.selectListStockCorrectionCodes = await this.datatask.Post(1071);
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(2481, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private recalcQuantityStockChange() {
        if (!this.edit) return;

        this.edit.quantity_stock_change = this.utility.parseNumber(this.edit.quantity_stock_new) - this.utility.parseNumber(this.edit.quantity_stock_now);
    }

    public onChanged(_: string | number, id: keyof Edit) {
        if (!this.edit) return;

        switch (id) {
            case 'quantity_stock_new':
                this.recalcQuantityStockChange();
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadEdit();
        this.loadStockCorrectionCodes();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    stockbatch_keyno: string;
    prod_id: string;
    prod_name: string;
    quantity_stock_now: string;
    quantity_stock_new: string;
    quantity_stock_change: string | number;
    stockcorrcode_keyno: string;
    note: string;
}

interface StockCorrectionCodeItem {
    stockcorrcode_keyno: string;
    stockcorrcode_name: string;
    orderby: number;
}
